import { render } from "./AstOptions.vue?vue&type=template&id=6fb77e71&scoped=true"
import script from "./AstOptions.vue?vue&type=script&lang=js"
export * from "./AstOptions.vue?vue&type=script&lang=js"

import "./AstOptions.vue?vue&type=style&index=0&id=6fb77e71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb77e71"]])

export default __exports__